export const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
export const mobileCheck = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(pointer: coarse)").matches || window.innerWidth < 600);
export const rn = (start = 0, end = 1) => start + Math.random() * (end - start);
export const ri = (start = 0, end = 1) => Math.floor(rn(start, end + 1));
export const sample = (items) =>
  items[Math.floor(Math.random() * items.length)];
export const q = (selector) => document.querySelector(selector);
export const color2Hex = (color) =>
  typeof color === "number" ? "#" + color.toString(16).padStart(6, "0") : color;
export const color2Rgb = (color, alpha = 1) => {
  const n = parseInt(color2Hex(color).slice(1), 16);
  return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${alpha})`;
};
export const getBrightness = (c) => 0.299 * c.r + 0.587 * c.g + 0.114 * c.b;
export function clearThree(root) {
  const seen = new Set();
  const dispose = (resource) => {
    if (resource && !seen.has(resource)) {
      seen.add(resource);
      resource.dispose?.();
    }
  };
  root?.traverse((obj) => {
    dispose(obj.geometry);
    for (const m of Array.isArray(obj.material) ? obj.material : [obj.material])
      if (m) {
        for (const value of Object.values(m))
          if (value?.isTexture) dispose(value);
        for (const u of Object.values(m.uniforms || {}))
          if (u.value?.isTexture) dispose(u.value);
        dispose(m);
      }
  });
  root?.clear();
}
